// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"3cd7ee52","417":"376a4cf0"}[chunkId] + ".chunk.js";
};